import styled, { css } from 'styled-components'

// PAX HEADER TAB STYLES STARTS
const PaxTabWrapper = styled.div`
	text-align: center;
	margin-bottom: 24px;
`

const Tab = styled.span`
	display: inline-block;
	padding: 4px 8px;
	font-weight: 600;
	font-size: 16px;
	line-height: 24px;
	letter-spacing: -0.231818px;
	color: #aaaaaa;
	cursor: pointer;
	margin: 0 4px 6px;

	${props =>
		props.active &&
		css`
			color: ${props => props.color || '#333333'};
			border-bottom: 2px solid ${props => props.color || '#000000'};
		`};
`
// PAX HEADER TAB STYLES ENDS

export const PaxTab = ({
	roomsCount = 1,
	activeIndex = 0,
	onClickAction = () => {},
	color,
}) => {
	return (
		<PaxTabWrapper>
			{Array.from(new Array(roomsCount)).map((room, roomNo) => {
				return (
					<Tab
						key={roomNo}
						active={roomNo === activeIndex}
						onClick={() => onClickAction(roomNo)}
						color={color}
					>
						{`Room ${roomNo + 1}`}
					</Tab>
				)
			})}
		</PaxTabWrapper>
	)
}
